export enum InventorizationTypeEnum {
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
}

export enum InventorizationStatusEnum {
  New = 'NEW',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Closed = 'CLOSED',
  Canceled = 'CANCELED',
}
